<template>
  <div class="page-wrap">
    <MCard title="AI 训练（演示）" title-align="center">
      <div class="ai-training">
        <MForm class="m-form" ref="form" v-bind="form" />

        <MTable v-bind="tableConfig"></MTable>
      </div>
    </MCard>
  </div>
</template>

<script>
import MTable from '@/components/mTable/m-table.vue';
import MForm from '@/components/form/v2.vue';
import MCard from '@/components/mCard/index.vue';
import { getAiTrainingList, insertAiTraining, updateCurrVersion } from '@/api/RTEAO';
import { formatTime } from '@/utils/date';
import { sleep } from '@/utils/utils';
import { isEmpty } from '@/utils/is';

export default {
  components: {
    MTable,
    MForm,
    MCard
  },
  data() {
    return {
      tableConfig: {
        loading: false,
        ref: 'table',
        height: '100%',
        hasPagination: false,
        multiSelection: [],
        tableData: [],
        tableColumn: [
          {
            label: '训练时间',
            prop: 'trainingTime',
            temp: ({ row }) => {
              return formatTime(row.trainingTime, 'yyyy-MM-dd hh:mm');
            }
          },
          {
            label: '训练版本',
            prop: 'version'
          },
          {
            label: '模型',
            prop: 'model'
          },
          {
            label: '是否是当前版本',
            prop: 'isCurrVersion',
            temp: ({ row }) => {
              return row.isCurrVersion === '1' ? '是' : '否';
            }
          }
        ]
      },
      form: {
        config: {
          formProps: {
            rules: {
              timeRange: [{ required: true, message: '请选择时间范围', trigger: 'blur' }],
              model: [
                {
                  required: true,
                  message: '请选择模型',
                  trigger: 'blur'
                }
              ]
            }
          },
          formItemAttrs: { style: 'margin-bottom: 5px; padding: 0 20px;' }
        },
        options: [
          { type: 'checkbox', prop: 'convertedDistance', componentProps: { label: '折算距离' } },
          { type: 'checkbox', prop: 'deviceDistance', componentProps: { label: '设备距离' } },
          {
            type: 'checkbox',
            prop: 'environmentalStatus',
            componentProps: { label: '环境状态' }
          },
          { type: 'checkbox', prop: 'humanTraffic', componentProps: { label: '人流量' } },
          {
            type: 'checkbox',
            prop: 'samplingHistory',
            componentProps: { label: '哨点历史采样情况' }
          },
          {
            type: 'checkbox',
            prop: 'distanceBetweenSentries',
            componentProps: { label: '哨点之间距离' }
          },
          {
            type: 'checkbox',
            prop: 'geographicalDistance',
            componentProps: { label: '地理位置距离' }
          },
          {
            label: '模型',
            type: 'select',
            prop: 'model',
            formItemAttrs: {
              style: 'line-height: 1; margin-bottom: 15px; padding: 0 20px;'
            },
            componentAttrs: {
              style: 'width: 100%'
            },
            componentProps: {
              popperAppendToBody: false,
              options: [{ label: 'HT-EAO', value: '1' }]
            }
          },
          {
            label: '时间范围',
            type: 'datePicker',
            prop: 'timeRange',
            formItemAttrs: {
              style: 'margin-bottom: 25px;padding: 0 20px;'
            },
            componentAttrs: {
              style: 'width: 100%;'
            },
            componentProps: {
              appendToBody: false,
              type: 'daterange',
              rangeSeparator: '-',
              startPlaceholder: '开始时间',
              endPlaceholder: '结束时间'
            }
          }
        ],
        operations: {
          attrs: {
            style: 'justify-content: center; flex-wrap: wrap; gap: 15px;'
          },
          buttonAttrs: {
            style: 'width: 6.5rem;'
          },
          list: [
            {
              text: '开始训练',
              loading: false,
              buttonProps: {
                type: 'primary',
                size: 'medium'
              },
              onClick: (_data, btn) => {
                const list = [];
                this.$refs.form.validateField(['timeRange', 'model'], async errMsg => {
                  errMsg && list.push(errMsg);

                  if (!isEmpty(list) || btn.loading) return;

                  btn.loading = true;

                  await sleep(4000);

                  await this.startTrain();

                  btn.loading = false;
                });
              }
            },
            {
              text: '重新训练',
              loading: false,
              buttonProps: {
                type: 'primary',
                size: 'medium'
              },
              onClick: async (_data, btn) => {
                this.$refs.form.validate(['timeRange'], async valid => {
                  if (!valid) return;
                  if (!this.tableConfig.multiSelection.length) {
                    this.$message.warning('请选择训练数据');
                    return;
                  }

                  btn.loading = true;

                  await sleep(4000);

                  // await this.startTrain();

                  btn.loading = false;
                });
              }
            },
            {
              text: '微调',
              loading: false,
              buttonProps: {
                type: 'primary',
                size: 'medium'
              },
              onClick: (_data, btn) => {
                this.$refs.form.validate(async valid => {
                  if (!valid) return;

                  if (!this.tableConfig.multiSelection.length) {
                    this.$message.warning('请选择训练数据');
                    return;
                  }

                  btn.loading = true;

                  await sleep(4000);

                  // await this.startTrain();

                  btn.loading = false;
                });
              }
            },
            {
              text: '更新AI模型',
              loading: false,
              buttonProps: {
                type: 'warning',
                size: 'medium'
              },
              onClick: async (_data, btn) => {
                btn.loading = true;

                await this.updateModel();

                btn.loading = false;
              }
            }
          ]
        },
        model: {
          convertedDistance: true,
          deviceDistance: true,
          environmentalStatus: true,
          humanTraffic: true,
          samplingHistory: true,
          distanceBetweenSentries: true,
          geographicalDistance: true,
          timeRange: [],
          model: ''
        },
        dataSource: {}
      }
    };
  },
  methods: {
    async startTrain() {
      try {
        // const res = await insertAiTraining(this.form.model);
        const res = await insertAiTraining({});

        if (res.code !== 200) return;
        this.initData();
      } catch (error) {
        console.log(error);
      }
    },
    async updateModel() {
      try {
        const selectedRows = this.tableConfig.multiSelection;
        if (selectedRows.length === 0) {
          this.$message.warning('请选择要更新的版本');
          return;
        }

        const row = selectedRows[0];
        const res = await updateCurrVersion({ id: row.id });

        if (res.code !== 200) {
          this.$message.error(res.message || '更新失败');
          return;
        }

        this.$message.success('更新成功');
        this.initData();
      } catch (error) {
        console.log(error);
        this.$message.error('更新失败');
      }
    },
    async initData() {
      if (this.tableConfig.loading) return;

      try {
        this.tableConfig.loading = true;

        const res = await getAiTrainingList();

        if (res.code !== 200) return;

        this.tableConfig.tableData.splice(0, Infinity, ...res.data);
      } catch (error) {
        console.log(error);
      } finally {
        this.tableConfig.loading = false;
      }
    }
  },
  watch: {
    'tableConfig.multiSelection'(n) {
      if (n.length <= 1) return;

      const temp = n.slice(-1)[0];

      this.$refs.table.clearSelection();

      this.$refs.table.toggleRowSelection(temp, true);
    }
  },
  mounted() {
    this.initData();
  }
};
</script>

<style lang="scss">
.ai-training {
  display: flex;
  box-sizing: border-box;
  height: 100%;

  .el-button {
    font-size: 1rem;
    width: 6.5rem;
  }

  .m-form {
    width: 20%;

    .el-form {
      &-item {
        &__label {
          font-size: 0.9rem;
        }

        &__content {
          line-height: 1.2rem;

          .el-input__inner {
            font-size: 1rem;
          }

          .el-date-table {
            font-size: 0.8rem;
          }

          .el-range-input {
            font-size: 1rem;
          }

          .el-date-range-picker__header {
            .el-picker-panel__icon-btn {
              font-size: 0.8rem;
            }

            div {
              font-size: 1rem;
            }
          }

          .el-select-dropdown__item {
            font-size: 1rem;
            height: 2rem;
            line-height: 2rem;
          }

          .el-checkbox {
            height: 2rem;
            line-height: 2rem;
            font-size: 1.15rem;

            &__label {
              font-size: 1.15rem;
            }

            .el-checkbox__inner {
              width: 1.05rem;
              height: 1.05rem;
              border: 1px solid #078ca3;

              &::before {
                top: 48%;
              }

              &::after {
                left: 32%;
                top: 15%;
                width: 0.26rem;
                height: 0.5rem;
              }
            }
          }
        }
      }
    }
  }

  .m-table {
    width: 80%;
  }
}
</style>
